<template>
  <div id="user-chooseApproval">
    <mt-header title="选择认证方式">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
    </mt-header>
    <div id="user-chooseApproval_content">

      <div class="user-chooseApproval-ft">

        <div class="user-chooseApproval-ft-show" v-for="(item,index) in list">
          <div class="user-chooseApproval-ft-radio">
            <input type="radio" name="test"  :value="item.value" :checked="item.isCheck" @change="changeInput(index)">
          </div>
          <span class="user-chooseApproval-ft-detail">{{item.name}}</span>
        </div>
      </div>

      <div class="user-chooseApproval-submit">
        <mt-button class="login-btn" size="large" type="primary" @click="makeSure()">确定</mt-button>
      </div>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import {MessageBox} from 'mint-ui';
  import cheader from '@/components/header';
  export default {
    data () {
      return {
        list:[{value:'bank',isCheck:true,name :'银行卡认证'}],
        approvalInfo:{},
        returnNo:'',
        _selected:''
      }
    },
    methods: {
      test:function () {
        var str=location.href; //取得整个地址栏
        var num=str.indexOf("?")
        str=str.substr(num+1); //取得所有参数   stringvar.substr(start [, length ]

        var arr=str.split("&"); //各个参数放到数组里
        console.log(arr)
        for(var i=0;i < arr.length;i++){
          num=arr[i].indexOf("=");
          if(num>0){
            var name=arr[i].substring(0,num);
            var value=arr[i].substr(num+1);
            this[name]=value;
          }
        }
      },
      zhima:function () {
        var message = '认证完成';
        this.$http.post(
          domain("_zhimaApproval"), {
            cert_name: this.approvalInfo.username,
            cert_no: this.approvalInfo.userCardId,
            signCode:this.approvalInfo.signCode
          },
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            var url = response.data.data.url;
            this.returnNo =  response.data.data.returnNo;
            window.location.href = url;
          }, function (error) {
          })



      },
      bank:function () {
        this.$router.push({
          path: '/user/bankApproval',
          name: 'bankApproval',
          query: {
            _router: {
              name: 'user',
              path: "/user/chooseApproval"
            },
            username: this.approvalInfo.username,
            userCardId: this.approvalInfo.userCardId,
            signCode: this.approvalInfo.signCode,
            _selected: this._selected,
            approvalInfo:this.approvalInfo
          }
        })
      },
      makeSure:function () {
        var selectedValue;
        this.list.map(function (v) {
          if(v.isCheck){
            selectedValue=v.value;
          }
        });
        if('zhima' == selectedValue ){
          this.zhima();
        }else{
          this.bank();
        }
      },
      changeInput(index){
        this.list.map(function (v,i) {
          if(i==index){
            v.isCheck = true
          }else{
            v.isCheck = false
          }
        });
      },
      goBack: function () {
        //history.go(-1); //后退1页
        this.$router.push({
          path: '/user/approval',
          name: 'approval',
          query: {
            _router: {
              returnName: 'main',
              returnPath: "/main"
            }
          }
        })
      },
      initParams(){
          this.approvalInfo = this.$route.query.approvalInfo;
      },
      fetcchMsg(){
      }
    },
    filters: {
    },
    components: {},
    mounted: function () {
      this.initParams();
    }

  }
</script>
<style>
  #user-chooseApproval {
    position: fixed;
    height: 100%;
    background-color: #ECECEC;
    width: 100%;
  }
  .user-chooseApproval-ft {
    margin-left: 4%;
    margin-right: 4%;
    background-color: #ffffff;
    font-size: 1rem;
    color: #7d7d7d;
    font-family: "Microsoft YaHei";
    border-radius: 5px;
    margin-top: 0.4rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .user-chooseApproval-ft-show {
    padding-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .user-chooseApproval-ft-radio{
    float: left;
    text-align: right;
    display: block;
    margin-left: 3rem;
  }

  .user-chooseApproval-ft-detail{
    margin-left: 0.5rem;
  }

  .user-chooseApproval-submit{
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    padding-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/module/user/ChooseApproval.vue